// extracted by mini-css-extract-plugin
module.exports = {"container":"PartialPurchasesError_container__FxMaT","reloadBtn":"PartialPurchasesError_reloadBtn__r2tWJ"};